import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ScrollableTabs, Text, TextAreaRichEditor } from '@reveni-io/reveni-ui'

import { getLanguageLabels } from '@/configuration/helpers/helpers'

import useLanguageRichTextInput from './hooks/useLanguageRichTextInput/useLanguageRichTextInput'
import { editorToolbarModules } from './constants'
import * as Styles from './styles'

const LanguageRichTextInput = ({
  languages,
  value,
  onChange,
  externalErrorLanguages = [],
  inputLabel,
  helperText,
  showInputError = false,
  backgroundColor,
  disabled,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { orderedLanguages, textLanguage, setTextLanguage, hasError, handleChange } = useLanguageRichTextInput({
    languages,
    onChange,
    externalErrorLanguages,
  })

  const languageLabels = getLanguageLabels(t)
  const showCurrentError = showInputError && hasError(textLanguage)

  return (
    <Styles.Container>
      <ScrollableTabs
        tabs={orderedLanguages.map(language => ({
          label: languageLabels[language],
          value: language,
          error: hasError(language),
        }))}
        value={textLanguage}
        onChange={setTextLanguage}
      />
      <Styles.EditorContainer>
        <TextAreaRichEditor
          key={textLanguage}
          label={inputLabel}
          value={value?.[textLanguage] || ''}
          onChange={handleChange}
          textType="html"
          richEditorTheme="bubble"
          richEditorToolbarModules={editorToolbarModules}
          minHeight="56px"
          fullWidth
          backgroundColor={backgroundColor}
          disabled={disabled}
          error={showCurrentError}
        />
        {showCurrentError && helperText && (
          <Text type="bodySRegular" color={theme.colors.danger.default}>
            {helperText}
          </Text>
        )}
      </Styles.EditorContainer>
    </Styles.Container>
  )
}

export default LanguageRichTextInput
